import { Component, OnDestroy, OnInit, Input } from "@angular/core";
import { Subscription } from "rxjs";
import { DashboardMenuTabSelectorService } from "../dashboardCommon/services/dashboardMenuTabSelector.service";
import { TabEntry } from "./tabEntry";

@Component({
    selector: 'dashboard-menu',
    templateUrl: './dashboardMenu.component.html',
    styleUrls: ['./dashboardMenu.component.css'],
    standalone: false
})
export class DashboardMenuComponent implements OnInit, OnDestroy {
    public selectedTab: number;
    private selectedTabChangedSubscription: Subscription;

    constructor(private selectorService: DashboardMenuTabSelectorService) {
    }

    @Input()
    public tabEntries: TabEntry[];

    @Input()
    public selectedOfficeIsRecruitment: boolean;

    public ngOnInit(): void {
        this.selectedTabChangedSubscription = this.selectorService.selectedTabChanged.subscribe((index) => this.selectedTab = index);
        this.selectorService.selectedTab = 0;
    }

    public ngOnDestroy(): void {
        if (this.selectedTabChangedSubscription) this.selectedTabChangedSubscription.unsubscribe();
    }

    public onSelectTab(event: Event, index: number): void {
        if (event) event.stopPropagation();
        this.selectorService.selectedTab = index;
        window.scroll(0, 0);
    }
}